<template>
    <div
        v-tooltip="disabledTooltip"
        class="RbacDisableDefaultGuard"
        :class="{'RbacDisableDefaultGuard--disabled': isDisabled}"
    >
        <template v-if="isLoadingUserPermissions">
            <span>Loading...</span>
        </template>
        <slot v-else />
    </div>
</template>

<style lang="scss">
.RbacDisableDefaultGuard {
    &--disabled {
        opacity: 0.3;
        cursor: not-allowed;

        > * {
            pointer-events: none;
        }
    }
}
</style>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';

    import { RbacFeature } from '@evidentid/tprm-portal-lib/models/rbac';

    import { useUserStore } from '../../../auth/store/user';
    import { UserState } from '../../../auth/types';

    export default defineComponent({
        name: 'RbacDisableDefaultGuard',
        props: {
            features: {
                type: Array as PropType<RbacFeature[]>,
                required: true,
            },
            relyOnLoadingUserPermissions: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
            requiredAny: {
                type: Boolean as PropType<boolean>,
                default: false,
            },
            disabledMessage: {
                type: String as PropType<string>,
                default: 'View Only. You do not have permission to make changes.',
            },
        },
        computed: {
            userStore(): UserState {
                return useUserStore();
            },
            isLoadingUserPermissions(): boolean {
                return false;
            },
            userFeatures(): Record<RbacFeature, boolean> | null {
                return this.userStore.currentRpRbacFeatures;
            },
            isDisabled(): boolean {
                if (this.requiredAny) {
                    // disable if all features are missing. in other word, enable if user has any features
                    return this.features.every((feature) => !this.userFeatures?.[feature]);
                }
                // disable if there is any missing feature. in other word, enable if user has all features
                return this.features.some((feature) => !this.userFeatures?.[feature]);
            },
            disabledTooltip(): string | null {
                return this.isDisabled ? this.disabledMessage : null;
            },
        },
    });
</script>
